import { setTestDriver } from '@oracle/oraclejet-testing/UNSAFE_Driver';
import { SeleniumDriver } from '@oracle/oraclejet-selenium-driver/UNSAFE_SeleniumDriver';
import { WebDriver, WebElement } from 'selenium-webdriver';

let activeDriver: WebDriver;
let activeSeleniumDriver: SeleniumDriver;

function getTestDriver(driver: WebDriver) {
  if (driver !== activeDriver) {
    activeDriver = driver;
    activeSeleniumDriver = new SeleniumDriver(driver);
    setTestDriver(activeSeleniumDriver);
  }
  return activeSeleniumDriver;
}

/**
 * Get a TestElement for the given WebElement
 * @param webElement
 * @returns
 */
export function getTestElement(webElement: WebElement) {
  return getTestDriver(webElement.getDriver()).getTestElement(webElement);
}
